/**
 * Browser features detection
 */

/**
 * Detect hover
 * 
 * @returns {Boolean}
 */
const canHover = () => {
  return !(!window.matchMedia('(hover: hover)').matches || ('ontouchstart' in window) );
};

export default {
  noHover: !canHover()
};